export default __webpack_public_path__ + "static/media/thumbnail.3505c779.png";